import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Col, Row, Form } from "react-bootstrap";
import { UserRumModalProps } from '../../types';

export default function UserRumModal({ closeModal, show, rum, requestRum, saveNotes}: UserRumModalProps): JSX.Element {    

    if(!rum) {
        return (
            <></>
        )
    }

    function request(): void {
        if (!rum) return;
        
        const isDelete = "requested_on" in rum && !rum.rejected_on ? true : false;
        const isGift = isDelete ? false : (document.getElementById("is_gift") as HTMLInputElement)?.checked || false;
        const giftGiver = isDelete ? '' : (document.getElementById("gift_giver") as HTMLInputElement)?.value || '';
        console.log("isDelte: " + isDelete + "isgift: " + isGift + "by" + giftGiver);
        requestRum(rum.id, isDelete, isGift, giftGiver);
    }

    function formattedDateTime(dateString: string): string {
        const date = new Date(Date.parse(dateString));

        let ampm = "AM";

        let hours = date.getHours();
        if(hours > 12) {
            hours = hours - 12;
            ampm = "PM";
        } else if(hours === 0) {
            hours = 12;
        } else if (hours === 12) {
            ampm = "PM";
        }

        return date.toDateString() + ", " + hours + ":" + String(date.getMinutes()).padStart(2, '0') + " " + ampm;
    }

    function sendNotes(): void {
        const notesElement = document.getElementById('notesArea') as HTMLTextAreaElement;
        saveNotes(notesElement?.value || '');
    }

    function detailRow(label: string, value: React.ReactNode): JSX.Element | null {
        if (value === null || value === undefined || value === "") {
            return null;
        }
        return (
            <Row className="mt-2">
                <Col xs={12} sm={3} className="text-sm-end text-xs-start">
                    <label className="fw-bold">{label}</label>
                </Col>
                <Col xs={12} sm={8}>
                    {value}
                </Col>
            </Row>
        );
    }

    const r = rum as any;

    let pourSizeDisplay: string | null = null;
    if (r.pour_size === "1") pourSizeDisplay = "1 oz";
    else if (r.pour_size === "2") pourSizeDisplay = "2 oz";
    else if (r.pour_size === "other") pourSizeDisplay = "Other";
    else if (r.pour_size != null && r.pour_size !== "") pourSizeDisplay = r.pour_size;

    let pourDisplay: string | null = pourSizeDisplay;
    if (r.pour_size_notes != null && r.pour_size_notes !== "") {
        pourDisplay = pourDisplay ? `${pourDisplay} (${r.pour_size_notes})` : r.pour_size_notes;
    }

    const alcoholDisplay = r.alcohol_percentage != null && r.alcohol_percentage !== "" && parseFloat(r.alcohol_percentage) !== 0
        ? `${r.alcohol_percentage}%`
        : null;

    let displayString = "";

    if(rum.rejected_on !== null) {
        let rejectionReason = "No reason given"
        if(rum.rejection_reason !== null && rum.rejection_reason !== undefined) {
            rejectionReason = rum.rejection_reason;
        }
        displayString = "Rejected By " + rum.approver + ". " + rejectionReason;
    } else if(!!(rum as any).approved_on) {
        displayString = " Approved by " + rum.approver + ", " + formattedDateTime((rum as any).approved_on);
    } else if(!!rum.requested_on) {
        displayString = " Requested " + formattedDateTime(rum.requested_on);
    } 

    return (
        <>
        <Modal show={show} onHide={closeModal} size="lg">
            <Modal.Header closeButton>
            <Modal.Title>
                {rum != null
                    ? `${rum.bevager_name ?? ""}${
                        rum.inventory_id != null && rum.inventory_id !== ""
                            ? `, #${rum.inventory_id}`
                            : ""
                      }`
                    : ""}
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs={12} sm={3} className="text-sm-end text-xs-start">
                    <label className="fw-bold">Country</label>
                    </Col>
                    <Col xs={12} sm={8}>
                    {rum != null ? rum.origin_country : ""}
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12} sm={3} className="text-sm-end text-xs-start">
                    <label className="fw-bold">Price</label>
                    </Col>
                    <Col xs={12} sm={8}>
                    {rum != null ? "$" + parseFloat(rum.price.toString()).toFixed(0) : ""}
                    </Col>
                </Row>
                {detailRow("Alcohol Percentage", alcoholDisplay)}
                {detailRow("Pour", pourDisplay)}
                {detailRow("Product Name", r.product_name)}
                {detailRow("Brand Name", r.brand_name)}
                {detailRow("US State", r.us_state)}
                {detailRow("Distillery", r.distillery)}
                {detailRow("Cask Finish", r.cask_finish)}
                {r.is_migrated ? detailRow("Raw Material", r.raw_material) : null}
                {detailRow("Year Distilled", r.year_distilled)}
                {detailRow("Year Bottled", r.year_bottled)}
                {detailRow("Age", r.age)}
                {detailRow("Marque", r.marque)}
                {detailRow("Production Method", r.production_method)}
                {detailRow("Cove Notes", r.cove_notes)}
                <Row className="mt-2">
                    <Col xs={12} sm={3} className="text-sm-end text-xs-start">
                        <label className="fw-bold">Request Status</label>
                    </Col>
                    <Col xs={12} sm={8}>
                    {
                        rum && !!rum.approver
                        ? "rejected_on" in rum ? <div>{displayString}<br /><Button style={{padding: 0}} variant="link" onClick={request}>Request</Button><Form.Check type="checkbox" label="Is Gift" id='is_gift' /><Form.Control type="text" id="gift_giver" placeholder="Gifted By" /></div>
                        : <div>{displayString}</div>
                        : rum && "requested_on" in rum
                        ? <div>{displayString}<br /><Button style={{padding: 0}} variant="link" onClick={request}>Cancel Request</Button></div>
                        : <><Button style={{padding: 0}} variant="link" onClick={request}>Request</Button><Form.Check type="checkbox" label="Is Gift" id='is_gift' /><Form.Control type="text" id="gift_giver" placeholder="Gifted By" /></>
                    }
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12} sm={3} className="text-sm-end text-xs-start">
                        <label className="fw-bold">Notes</label>
                    </Col>
                    <Col xs={12} sm={8}>
                        <textarea id="notesArea" defaultValue={"notes" in rum ? rum.notes : ""}>
                        </textarea>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={sendNotes}>
                    Save Notes
                </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}
